$(function() {
    // ヘッダーメニュー
	$(".js-mobile-draw-trigger-menu").click(function() {
		$(".js-menu-draw").hasClass("mfp-hide")
            ? $(".js-menu-draw").removeClass("mfp-hide")
            : $(".js-menu-draw").addClass("mfp-hide");
        if( $(this).hasClass("js-drawer-active") ){
			$(this).removeClass("js-drawer-active");
			$(this).find('.mobile-draw__icon-text').text('メニュー');
		} else {
			$(this).addClass("js-drawer-active");
			$(this).find('.mobile-draw__icon-text').text('閉じる');
		}

	}),

    // ヘッダーの高さ
    $(window).on('load resize', function(){
        let l_header = $("header").outerHeight();
        $(".mobile-mega-menu-draw").css("top", l_header + "px");
    });

    // PCのメガメニュー実装
	outerLoop: for (let i = 0; i < $(".mobile-mega-menu-draw .list-menu .list-menu__link").length; i++) {
		let js_megamenu_list = $(".mobile-mega-menu-draw .list-menu .list-menu__link").eq(i),
      	js_megamenu_list_text = js_megamenu_list.text();
		for (let di = 0; di < $(".js-megamenu-area[is-megamenu-data]").length; di++) {
			let js_megamenu_content = $(".js-megamenu-area[is-megamenu-data]").eq(di),
				js_megamenu_content_data = js_megamenu_content.attr("is-megamenu-data");

			if (js_megamenu_list_text == js_megamenu_content_data) {

		        // リンク先にactiveをつける
				js_megamenu_list.addClass("js-active");

        		// アニメーション実装してメガメニューを表示せる
				let is_megaemu_target = $('.js-megamenu-area[is-megamenu-data="' + js_megamenu_content_data + '"]').clone();
				$(".mobile-draw__footer__contents").append(is_megaemu_target).html();

				// SMPのハンバーガーメニュー内にタイプを入れる
				$(".mobile-draw__wrapper")
					.removeClass('type1')
					.removeClass('type2')
					.addClass(is_megaemu_target.attr("is-datatype"))
					.removeClass('image_one_sets')
					.removeClass('image_two_sets')
					.addClass(is_megaemu_target.attr("is-dataimagetype"));

		        //スライダー実装
				let is_data_id = is_megaemu_target.attr("is-dataid");
				if (is_megaemu_target.attr("is-datatype") == "type1") {
					const headerswiper = new Swiper("#slider-component--" + is_data_id, {
						slidesPerView: 2.1,
						spaceBetween: 10,
						slidesPerGroup: 1,
						breakpoints: {
							768: {
								slidesPerView: 3,
								spaceBetween: 10,
								slidesPerGroup: 3
							},
							990: {
								slidesPerView: 5.5,
								spaceBetween: 20,
								slidesPerGroup: 5
							}
						},
						navigation: {
							nextEl: "#slider-next--" + is_data_id,
							prevEl: "#slider-prev--" + is_data_id
						}
					})
				} else {
					const headerswiper = new Swiper("#slider-component--" + is_data_id, {
						slidesPerView: 1.2,
						spaceBetween: 10,
						slidesPerGroup: 1,
						breakpoints: {
							990: {
								slidesPerView: 2.2,
								spaceBetween: 0,
								slidesPerGroup: 2
							}
						},
						navigation: {
							nextEl: "#slider-next--" + is_data_id,
							prevEl: "#slider-prev--" + is_data_id
						}
					} )
				}
				break outerLoop
			}
		}
	}

    // SMPのメニュー実装
    outerSpLoop: for (let i = 0; i < $(".mobile-draw__footer__contents--inner.list-menu .list-menu__link").length; i++) {
		let js_megamenu_list = $(".mobile-draw__footer__contents--inner.list-menu .list-menu__link").eq(i),
      	js_megamenu_list_text = js_megamenu_list.text();
        for (let di = 0; di < $(".js-megamenu-area[is-megamenu-data]").length; di++) {
          let js_megamenu_content = $(".js-megamenu-area[is-megamenu-data]").eq(di),
          js_megamenu_content_data = js_megamenu_content.attr("is-megamenu-data");
          if (js_megamenu_list_text.indexOf(js_megamenu_content_data) != -1) {
            js_megamenu_list.addClass("js-active");
            break outerSpLoop;
          }
        }
    }

	// カテゴリメニュー PC・SMPデバイス判定
	js_megamenu_lists = [];
	for (let i = 0; i < $(".js-megamenu-area").length; i++ ) {
		var js_megamenu_list = $(".js-megamenu-area").eq(i);
		js_megamenu_lists.push(js_megamenu_list.attr('is-categoryname-data'));
	}
	for (let li = 0; li < $('.list-menu > .list-menu__item-current').length; li++ ) {
		let list_menu = $(".list-menu > .list-menu__item-current").eq(li);
		if( js_megamenu_lists.includes(list_menu.attr('js-list-menu__current')) ) {
			let is_device = $(".js-megamenu-area[is-categoryname-data*='" + list_menu.attr('js-list-menu__current') +"']").attr('is-device'); // デバイス情報を取得
			list_menu.addClass(is_device); // 親カテゴリにclass名を付与
		}
	}	

    // SMPのメニュー・PCのメニューをクリックした時のイベント処理
	$( ".mobile-mega-menu-draw .list-menu .list-menu__link, .mobile-draw__footer__contents--inner .list-menu .list-menu__link" ).on('click', function(){
		let js_megamenu_list_text = $(this).text();

		// SMPでありかつハンバーガーメニューはそのまま遷移させる
		if( 
			window.matchMedia("(max-width: 980px)").matches &&
			$(this).parents('.mobile-draw__footer__contents--inner').length == 0)
		{
			return true;
		}

		for (let di = 0; di < $(".js-megamenu-area[is-megamenu-data]").length; di++) {
			let js_megamenu_content = $(".js-megamenu-area[is-megamenu-data]").eq(di),
				js_megamenu_content_data = js_megamenu_content.attr("is-megamenu-data");
			if (js_megamenu_list_text == js_megamenu_content_data) {

				// リンク先にclassを削除したり付与したりする
				$(".mobile-mega-menu-draw .list-menu__item .list-menu__link").removeClass("js-active");
				$(this).addClass("js-active");

				// アニメーション実装してメガメニューを表示せる
				let is_megaemu_target = $('.js-megamenu-area[is-megamenu-data="' + js_megamenu_content_data + '"]').clone();
				$(".mobile-draw__footer__contents")
					.fadeOut( 0 );
				$(".mobile-draw__footer__contents .js-megamenu-area")
					.remove();
				$(".mobile-draw__footer__contents")
					.fadeIn( 300 )
					.append(is_megaemu_target).html();

				// SMPのハンバーガーメニュー内にタイプを入れる
				$(".mobile-draw__wrapper")
					.removeClass('type1')
					.removeClass('type2')
					.addClass(is_megaemu_target.attr("is-datatype"))
					.removeClass('image_one_sets')
					.removeClass('image_two_sets')
					.addClass(is_megaemu_target.attr("is-dataimagetype"));

				console.log(is_megaemu_target.attr("is-dataimagetype"));

				//スライダー実装
				let is_data_id = is_megaemu_target.attr("is-dataid");                

				if (is_megaemu_target.attr("is-datatype") == "type1") {
					const headerswiper = new Swiper("#slider-component--" + is_data_id, {
						slidesPerView: 2.1,
						spaceBetween: 10,
						slidesPerGroup: 1,
						breakpoints: {
							768: {
								slidesPerView: 3,
								spaceBetween: 10,
								slidesPerGroup: 3
							},
							990: {
								slidesPerView: 5.5,
								spaceBetween: 20,
								slidesPerGroup: 5
							}
						},
						navigation: {
							nextEl: "#slider-next--" + is_data_id,
							prevEl: "#slider-prev--" + is_data_id
						}
					})
				} else {
					const headerswiper = new Swiper("#slider-component--" + is_data_id, {
						slidesPerView: 1.2,
						spaceBetween: 10,
						slidesPerGroup: 1,
						breakpoints: {
							990: {
								slidesPerView: 2.2,
								spaceBetween: 0,
								slidesPerGroup: 2
							}
						},
						navigation: {
							nextEl: "#slider-next--" + is_data_id,
							prevEl: "#slider-prev--" + is_data_id
						}
					})
				}
				return false;
			}
		}
	}),
    window.matchMedia("(max-width: 980px)").matches
        ? $(".list-menu__item-current details").removeAttr("open")
        : $(".list-menu__item-current details").attr("open");

	// 検索ボックス
    $(".js-search-draw details summary").click(function() {
		$(".search-modal__content details").removeAttr("open"),
        $(this).parent("details").attr("open")
	})
	$(".js-search-draw .modal-overlay").click(function() {
		$('.js-search-draw .js-close-mfp').click();
	});

  // フッターメニュー
  $('.footer-nav__toggle-bt').click(function () {
    if( $(this).hasClass('open') ) {
      $(this).removeClass('open');
      $(this).next().removeClass('open');
    } else {
      $(this).addClass('open');
      $(this).next().addClass('open');
    }
  });

  // コレクション一覧
  $(document).on('click', '.collection-sidebar__filter-trigger, .collection-sidebar__filter-close', function() {
    const $filterGroup = $(this).closest('.collection-sidebar__filter-group');
    const isOpen = $filterGroup.hasClass('js-filter-open');

    $filterGroup.toggleClass('js-filter-open', !isOpen);
    
    setTimeout(() => {
        $filterGroup.attr('open', !isOpen ? '' : null);
    }, 300);
  });
});